import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties.ts";
import type { SeriesResponse } from "~types/series.ts";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect";

type Props = SelectBaseSingleProperties<InfinitySelectOption> & {
  stageCode?: string;
};

export const SelectSeries = ({ value, stageCode, ...props }: Props) => {
  const { sport, organizationId, seasonId } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: SeriesResponse) =>
    (response?.data || []).map((x) => ({ label: x.nameLocal, value: x.seriesCode }));

  const filterParameters = stageCode ? { stageCode: stageCode } : undefined;

  return (
    <InfinitySelect<SeriesResponse>
      {...props}
      url={`${sport}/o/${organizationId}/seasons/${seasonId}/series`}
      filterParameters={filterParameters}
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.SEASON_SERIES}
      permissionOperation={PermissionOperations.READ}
      resetOptionsDependencies={[stageCode]}
    />
  );
};
